import { useState, useEffect } from "react"
import Sidebar from "../components/Sidebar";
import Notification from "../components/Notification";
import Header from "../components/Header";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowUpFromBracket, faArrowUpRightFromSquare, faCaretDown, faCaretUp, faCircleNotch, faClone, faCode, faCommentDots, faFileLines, faInfoCircle, faLink, faMagnifyingGlass, faUser} from '@fortawesome/free-solid-svg-icons'
import { useUser } from "../utils/UserContext";
import { useLocation } from 'react-router-dom';
import TradingViewWidget from "../components/TradingViewWidget";
import { formatLargeNumber, formatCurrency } from '../utils/currencyUtils';
import { faStar } from "@fortawesome/free-regular-svg-icons";

function Marketdetails() {
  const { user } = useUser();
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const coinSymbol = params.get('symbol');
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  const [notificationbar, setNotificationbar] = useState(false);
  const toggleNotification = () => {
    setNotificationbar(!notificationbar);
  };
  const [settingsBar, setSettingsBar] = useState(false);
  const toggleSettingsBar = () => {
    setSettingsBar(!settingsBar);
  };
  const [cryptoDetails, setCryptoDetails] = useState([]);
  const [cryptoInfo, setCryptoInfo] = useState([]);
  useEffect(() => {
      fetch(`/coin_list.txt`)
      .then((res) => res.json())
      .then((data) => {
      var coinList = data.data;
      const updatedData = coinList.map((coin, index) => ({
          id: index + 1,
          coin_id: coin.id,
          logo: `https://s2.coinmarketcap.com/static/img/coins/64x64/${coin.id}.png`,
          name: coin.name,
          type: 'crypto',
          symbol: coin.symbol,
          price: Number(coin.quote.USD.price.toFixed(2)),
          circulating_supply: coin.circulating_supply,
          supply_per: coin.max_supply ? Number((coin.total_supply/coin.max_supply) * 100).toFixed(2) : 0,
          volume: coin.quote.USD.volume_24h,
          volume_24h: Number(coin.quote.USD.volume_change_24h.toFixed(2)),
          market_cap: coin.quote.USD.market_cap,
          market_cap_dominance: coin.quote.USD.market_cap_dominance,
          fully_diluted_market_cap: coin.quote.USD.fully_diluted_market_cap,
          platformLogo: coin.platform && coin.platform.id ? `https://s2.coinmarketcap.com/static/img/coins/64x64/${coin.platform.id}.png` : `https://s2.coinmarketcap.com/static/img/coins/64x64/${coin.id}.png`,
          platformName: coin.platform && coin.platform.name ? coin.platform.name : coin.name,
          platformSymbol: coin.platform && coin.platform.symbol ? coin.platform.symbol : coin.symbol,
          cmc_rank: coin.cmc_rank,
          date_added: coin.date_added,
          last_updated: coin.last_updated,
          max_supply: coin.max_supply ? coin.max_supply : 0,
          total_supply: coin.total_supply ? coin.total_supply : 0,
          percent_1h: Number(coin.quote.USD.percent_change_1h.toFixed(2)),
          percent_7d: Number(coin.quote.USD.percent_change_7d.toFixed(2)),
          percent_24h: Number(coin.quote.USD.percent_change_24h.toFixed(2)),
          percent_30d: Number(coin.quote.USD.percent_change_30d.toFixed(2)),
          percent_60d: Number(coin.quote.USD.percent_change_60d.toFixed(2)),
          percent_90d: Number(coin.quote.USD.percent_change_90d.toFixed(2)),
      }));
            console.log(updatedData)
      const foundCoin = updatedData.find(
        (coin) => coin.symbol.toLowerCase() === coinSymbol.toLowerCase()
      );
      if (foundCoin) {
        setCryptoDetails(foundCoin);
      }
      })
      .catch((err) => console.error("Error loading coin list:", err));
  }, []);
  useEffect(() => {
    if(cryptoDetails && cryptoDetails.symbol && cryptoDetails.id){
    setLoading(true);
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ fetchCrypto: true, symbol:cryptoDetails.symbol, slug:cryptoDetails.id })
    })
    .then(response => response.json())
    .then(data => {
      var coin_id = Number(cryptoDetails.id);
      var cryinfo = data.data[coin_id];
      if (cryinfo && cryinfo.urls) {
        const ws = cryinfo.urls.website[0].split('//').slice(-1)[0];
        const wb = ws.split('/');
        const web = wb[0];
        cryinfo.urls.web = web;
      }
      setCryptoInfo(cryinfo);
      setLoading(false);
    })
    .catch(err => {
      window.location.href = '/markets';
    })
    }
  }, [cryptoDetails]);
  const [dropdown, setDropdown] = useState(false);
  const [dropdown1, setDropdown1] = useState(false);
  const [dropdown2, setDropdown2] = useState(false);

  if (loading) {
    return <div style={{ textAlign: "center", marginTop: "20%" }}><FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '30px', color: '#ff6b35', opacity: '0.5'}} spin /></div>;
  }

  return (
    <div className="container-fluid">
      <div className="row g-0">
        <Notification isOpen={notificationbar} toggleNotification={toggleNotification}/>
        <Sidebar title={cryptoDetails.name} isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} toggleSettingsBar={toggleSettingsBar} settingsBar={settingsBar}/>
        <div className="col ps-md-2 mainBar">
          <Header title={cryptoDetails.name} icon={<FontAwesomeIcon icon={faClone} style={{fontSize: '16px'}} />} toggleSidebar={toggleSidebar} toggleNotification={toggleNotification} toggleSettingsBar={toggleSettingsBar}/>
          <main className="mb-5">
            <div className="mycard p-3 mt-2">
              <div className="row">
                <div className="col-12">
                  <p className="mb-0 fw-bold" style={{fontSize:'20px'}}>Market stats</p>
                  <p className="mb-0" style={{fontSize:'14px'}}>Bitcoin Market Overview</p>
                </div>
                <div className="col-lg-4 g-4">
                  <div className="d-flex align-items-center flex-wrap">
                    <img src={cryptoDetails.logo} alt={cryptoDetails.name} style={{width: '30px'}} className="me-3" />
                    <p className="mb-0" style={{fontSize:'35px',fontWeight:'900'}}>{cryptoDetails.name}</p>
                    <div className="bg-tint px-2 py-1 ms-3 fw-bold rounded-2" style={{fontSize:'14px'}}>({cryptoDetails.symbol})</div>
                    <div className="bg-tint ms-3 d-flex align-items-center justify-content-center shadow rounded-2" style={{width:'33px',height:'32px'}}>
                      <FontAwesomeIcon icon={faStar} style={{fontSize: '16px'}} />
                    </div>
                    <div className="bg-tint ms-2 d-flex align-items-center justify-content-center shadow rounded-2" style={{width:'33px',height:'32px'}}>
                      <FontAwesomeIcon icon={faArrowUpFromBracket} style={{fontSize: '16px'}} />
                    </div>
                  </div>
                  <div className="d-flex align-items-center flex-wrap mt-2" style={{gap:'5px'}}>
                    <div className="bg-tint px-2 py-1 fw-bold rounded-2" style={{fontSize:'14px'}}>Rank #{cryptoDetails.cmc_rank}</div>
                    <div className="bg-tint px-2 py-1 fw-bold rounded-2" style={{fontSize:'14px'}}>{cryptoInfo.category}</div>
                    <div className="bg-tint px-2 py-1 fw-bold rounded-2" style={{fontSize:'14px'}}>On 3,523,452 watchlists</div>
                  </div>
                  <div className="d-flex align-items-center flex-wrap mt-4" style={{gap:'5px'}}>
                    <a href={cryptoInfo.urls.website['0']} target="_blank" className="bg-tint px-2 py-1 fw-bold rounded-2 noLink" style={{fontSize:'14px'}}><FontAwesomeIcon icon={faLink} style={{fontSize: '12px'}} /> {cryptoInfo.urls.web? cryptoInfo.urls.web : cryptoInfo.urls.website['0']} <FontAwesomeIcon icon={faArrowUpRightFromSquare} style={{fontSize: '12px'}} /></a>
                    <div className="bg-tint px-2 py-1 fw-bold rounded-2 noLink position-relative" style={{fontSize:'14px',cursor:'pointer'}} onClick={() => setDropdown(!dropdown)}><FontAwesomeIcon icon={faMagnifyingGlass} style={{fontSize: '12px'}} /> Explorers <FontAwesomeIcon icon={faCaretDown} style={{fontSize: '12px'}} />
                      {dropdown && (
                      <div className="p-3 rounded-2 position-absolute" style={{top:'25px', backgroundColor:'#161616'}}>
                        {cryptoInfo.urls.explorer.map((explorer) => {
                          var ws = explorer.split('//').slice(-1)[0];
                          var wb = ws.split('/');
                          var web = wb[0];
                        return (
                          <a href={explorer} className="noLink fw-bold text-nowrap my-1" style={{fontSize:'14px'}}>{web} <FontAwesomeIcon icon={faArrowUpRightFromSquare} style={{fontSize: '14px'}} className="ms-2" /></a>
                        )})}
                      </div>
                      )}
                    </div>
                    <div className="bg-tint px-2 py-1 fw-bold rounded-2 noLink position-relative" style={{fontSize:'14px',cursor:'pointer'}} onClick={() => setDropdown1(!dropdown1)}><FontAwesomeIcon icon={faUser} style={{fontSize: '12px'}} /> Community <FontAwesomeIcon icon={faCaretDown} style={{fontSize: '12px'}} />
                      {dropdown1 && (
                      <div className="p-3 rounded-2 position-absolute" style={{top:'25px', backgroundColor:'#161616'}}>
                        {cryptoInfo?.urls?.message_board && (() => {
                          {cryptoInfo?.urls?.message_board.map((addred) => {
                          const ws = addred.split('//').slice(-1)[0];
                          const wb = ws.split('/');
                          const web = wb[0];
                          return (
                            <a href={addred} className="noLink fw-bold text-nowrap my-1" style={{ fontSize: '14px' }} target="_blank" rel="noopener noreferrer">
                              {web} <FontAwesomeIcon icon={faArrowUpRightFromSquare} style={{ fontSize: '14px' }} className="ms-2" />
                            </a>
                          );
                        })}})()}
                        {cryptoInfo?.urls?.twitter && (() => {
                          {cryptoInfo?.urls?.twitter.map((addred) => {
                          const ws = addred.split('//').slice(-1)[0];
                          const wb = ws.split('/');
                          const web = wb[0];
                          return (
                            <a href={addred} className="noLink fw-bold text-nowrap my-1" style={{ fontSize: '14px' }} target="_blank" rel="noopener noreferrer">
                              {web} <FontAwesomeIcon icon={faArrowUpRightFromSquare} style={{ fontSize: '14px' }} className="ms-2" />
                            </a>
                          );
                        })}})()}
                        {cryptoInfo?.urls?.facebook && (() => {
                          {cryptoInfo?.urls?.facebook.map((addred) => {
                          const ws = addred.split('//').slice(-1)[0];
                          const wb = ws.split('/');
                          const web = wb[0];
                          return (
                            <a href={addred} className="noLink fw-bold text-nowrap my-1" style={{ fontSize: '14px' }} target="_blank" rel="noopener noreferrer">
                              {web} <FontAwesomeIcon icon={faArrowUpRightFromSquare} style={{ fontSize: '14px' }} className="ms-2" />
                            </a>
                          );
                        })}})()}
                        {cryptoInfo?.urls?.reddit && (() => {
                          {cryptoInfo?.urls?.reddit.map((addred) => {
                          const ws = addred.split('//').slice(-1)[0];
                          const wb = ws.split('/');
                          const web = wb[0];
                          return (
                            <a href={addred} className="noLink fw-bold text-nowrap my-1" style={{ fontSize: '14px' }} target="_blank" rel="noopener noreferrer">
                              {web} <FontAwesomeIcon icon={faArrowUpRightFromSquare} style={{ fontSize: '14px' }} className="ms-2" />
                            </a>
                          );
                        })}})()}
                        {cryptoInfo?.urls?.announcement && (() => {
                          {cryptoInfo?.urls?.announcement.map((addred) => {
                          const ws = addred.split('//').slice(-1)[0];
                          const wb = ws.split('/');
                          const web = wb[0];
                          return (
                            <a href={addred} className="noLink fw-bold text-nowrap my-1" style={{ fontSize: '14px' }} target="_blank" rel="noopener noreferrer">
                              {web} <FontAwesomeIcon icon={faArrowUpRightFromSquare} style={{ fontSize: '14px' }} className="ms-2" />
                            </a>
                          );
                        })}})()}
                      </div>
                      )}
                    </div>
                  </div>
                  <div className="d-flex align-items-center flex-wrap mt-2" style={{gap:'5px'}}>
                    <div className="bg-tint px-2 py-1 fw-bold rounded-2 noLink position-relative" style={{fontSize:'14px',cursor:'pointer'}} onClick={() => setDropdown2(!dropdown2)}><FontAwesomeIcon icon={faCommentDots} style={{fontSize: '12px'}} /> Chats <FontAwesomeIcon icon={faCaretDown} style={{fontSize: '12px'}} />
                      {dropdown2 && (
                      <div className="p-3 rounded-2 position-absolute" style={{top:'25px', backgroundColor:'#161616'}}>
                        {cryptoInfo.urls.chat.map((chat) => {
                          var ws = chat.split('//').slice(-1)[0];
                          var wb = ws.split('/');
                          var web = wb[0];
                        return (
                          <a href={chat} className="noLink fw-bold text-nowrap my-1" style={{fontSize:'14px'}}>{web} <FontAwesomeIcon icon={faArrowUpRightFromSquare} style={{fontSize: '14px'}} className="ms-2" /></a>
                        )})}
                      </div>
                      )}
                    </div>
                    <a href={cryptoInfo.urls.source_code['0']} target="_blank" className="bg-tint px-2 py-1 fw-bold rounded-2 noLink" style={{fontSize:'12px'}}><FontAwesomeIcon icon={faCode} style={{fontSize: '14px'}} /> Source Code <FontAwesomeIcon icon={faArrowUpRightFromSquare} style={{fontSize: '12px'}} /></a>
                    <a href={cryptoInfo.urls.technical_doc['0']} target="_blank" className="bg-tint px-2 py-1 fw-bold rounded-2 noLink" style={{fontSize:'12px'}}><FontAwesomeIcon icon={faFileLines} style={{fontSize: '14px'}} /> Whitepaper <FontAwesomeIcon icon={faArrowUpRightFromSquare} style={{fontSize: '12px'}} /></a>
                  </div>
                  <div className="mt-2">
                    <p className="mb-0">Tags:</p>
                    <div className="d-flex align-items-center flex-wrap" style={{gap:'5px'}}>
                      {cryptoInfo['tag-names'].slice(0, 4).map((tag, index) => (
                          <div className="bg-tint px-2 py-1 mt-1 fw-bold rounded-2" style={{fontSize:'14px'}}>{tag}</div>
                      ))}
                    </div>
                  </div>
                </div>
                <div className="col-lg-8 g-4">
                  <p className="mb-0 fw-bold" style={{fontSize:'14px'}}><FontAwesomeIcon icon={faInfoCircle} style={{fontSize: '12px'}} className="me-1" /> {cryptoDetails.name} Price (USD)</p>
                  <div className="d-flex align-items-center">
                    <p className="mb-0" style={{fontSize:'35px',fontWeight:'900'}}>${formatCurrency(cryptoDetails.price)}</p>
                    <div className={`ms-3 py-1 px-2 fw-bold rounded-2 ${cryptoDetails.percent_24h > 0?'bg-success':'bg-danger'}`} style={{fontSize:'14px'}}>
                      <FontAwesomeIcon icon={cryptoDetails.percent_24h > 0 ? faCaretUp : faCaretDown } style={{fontSize: '14px'}} className="me-1" /> {formatCurrency(cryptoDetails.percent_24h)}% 
                    </div>
                  </div>
                  <div className="mt-2">
                    <p className="mb-0">Percent Change:</p>
                    <div className="d-flex align-items-center flex-wrap" style={{gap:'5px'}}>
                      <div className="bg-tint px-2 py-1 mt-1 fw-bold rounded-2" style={{fontSize:'14px'}}>1hr <span className={`mb-0 fw-normal ms-2 ${cryptoDetails.percent_1h > 0?'text-success':'text-danger'}`}>{formatCurrency(cryptoDetails.percent_1h)}</span></div>
                      <div className="bg-tint px-2 py-1 mt-1 fw-bold rounded-2" style={{fontSize:'14px'}}>24hr <span className={`mb-0 fw-normal ms-2 ${cryptoDetails.percent_24h > 0?'text-success':'text-danger'}`}>{formatCurrency(cryptoDetails.percent_24h)}</span></div>
                      <div className="bg-tint px-2 py-1 mt-1 fw-bold rounded-2" style={{fontSize:'14px'}}>7d <span className={`mb-0 fw-normal ms-2 ${cryptoDetails.percent_7d > 0?'text-success':'text-danger'}`}>{formatCurrency(cryptoDetails.percent_7d)}</span></div>
                      <div className="bg-tint px-2 py-1 mt-1 fw-bold rounded-2" style={{fontSize:'14px'}}>30d <span className={`mb-0 fw-normal ms-2 ${cryptoDetails.percent_30d > 0?'text-success':'text-danger'}`}>{formatCurrency(cryptoDetails.percent_30d)}</span></div>
                    </div>
                  </div>
                  <hr className="mb-0"/>
                  <div className="row">
                    <div className="col-lg-3 col-md-6 g-3">
                      <div className="mycard p-3">
                        <p className="mb-0 text-secondary" style={{fontSize:'14px'}}>Market Cap <FontAwesomeIcon icon={faInfoCircle} style={{fontSize: '12px'}} className="me-1" /></p>
                        <p className="mb-0 fw-bold mt-3" style={{fontSize:'18px'}}>${formatCurrency(cryptoDetails.market_cap)}</p>
                        <p className={`mb-0 ${cryptoDetails.market_cap_dominance > 0 ? 'text-success':'text-danger'}`} style={{fontSize:'14px'}}>{formatCurrency(cryptoDetails.market_cap_dominance)}%</p>
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-6 g-3">
                      <div className="mycard p-3">
                        <p className="mb-0 text-secondary" style={{fontSize:'14px'}}>Fully Diluted Market Cap <FontAwesomeIcon icon={faInfoCircle} style={{fontSize: '12px'}} className="me-1" /></p>
                        <p className="mb-0 fw-bold mt-3" style={{fontSize:'18px'}}>${formatCurrency(cryptoDetails.fully_diluted_market_cap)}</p>
                        <p className={`mb-0 ${cryptoDetails.percent_60d > 0 ? 'text-success':'text-danger'}`} style={{fontSize:'14px'}}>{formatCurrency(cryptoDetails.percent_60d)}%</p>
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-6 g-3">
                      <div className="mycard p-3">
                        <p className="mb-0 text-secondary" style={{fontSize:'14px'}}>Volume <span className="bg-tint px-2 py-1 lh-1 rounded-2 text-white ms-1" style={{fontSize:'12px'}}>24h</span> <FontAwesomeIcon icon={faInfoCircle} style={{fontSize: '12px'}} className="me-1" /></p>
                        <p className="mb-0 fw-bold mt-3" style={{fontSize:'18px'}}>${formatCurrency(cryptoDetails.volume)}</p>
                        <p className={`mb-0 ${cryptoDetails.volume_24h > 0 ? 'text-success':'text-danger'}`} style={{fontSize:'14px'}}>{formatCurrency(cryptoDetails.volume_24h)}%</p>
                        <hr className="my-1"/>
                        <div className="d-flex align-items-center justify-content-between">
                          <p className="mb-0" style={{fontSize:'14px'}}>CEX Vol <FontAwesomeIcon icon={faInfoCircle} style={{fontSize: '12px'}} className="ms-1" /></p>
                          <p className="mb-0">${formatLargeNumber(cryptoDetails.volume)}</p>
                        </div>
                        <div className="d-flex align-items-center justify-content-between">
                          <p className="mb-0" style={{fontSize:'14px'}}>DEX Vol <FontAwesomeIcon icon={faInfoCircle} style={{fontSize: '12px'}} className="ms-1" /></p>
                          <p className="mb-0">${formatLargeNumber(Number(cryptoDetails.volume) - ((75/100) * Number(cryptoDetails.volume)))}</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-6 g-3">
                      <div className="mycard p-3">
                        <p className="mb-0 text-secondary" style={{fontSize:'14px'}}>Circulating Supply  <FontAwesomeIcon icon={faInfoCircle} style={{fontSize: '12px'}} className="ms-1" /></p>
                        <div className="d-flex align-items-center justify-content-between mt-3">
                        <p className="mb-0 fw-bold" style={{fontSize:'18px'}}>{formatCurrency(cryptoDetails.circulating_supply)}</p>
                        <p className={`mb-0 ${cryptoDetails.supply_per > 0 ? 'text-success':'text-danger'}`} style={{fontSize:'14px'}}>{formatCurrency(cryptoDetails.supply_per)}%</p>
                        </div>
                        <div className="rounded-pill w-100 p-0 my-2" style={{height:'4px', backgroundColor:'darkgray'}}>
                          <div className="rounded-pill bg-secondary h-100" style={{width: cryptoDetails.supply_per+'%'}}></div>
                        </div>
                        <div className="d-flex align-items-center justify-content-between">
                          <p className="mb-0" style={{fontSize:'14px'}}>Max Supply <FontAwesomeIcon icon={faInfoCircle} style={{fontSize: '12px'}} className="ms-1" /></p>
                          <p className="mb-0">{formatLargeNumber(cryptoDetails.max_supply)}</p>
                        </div>
                        <div className="d-flex align-items-center justify-content-between">
                          <p className="mb-0" style={{fontSize:'14px'}}>Total Supply <FontAwesomeIcon icon={faInfoCircle} style={{fontSize: '12px'}} className="ms-1" /></p>
                          <p className="mb-0">{formatLargeNumber(cryptoDetails.total_supply)}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr/>
                </div>
                <div className="col-12 mt-4">
                  <h5 className="text-prime" style={{fontWeight:'900'}}>{cryptoDetails.name} to USD Chart</h5>
                  <TradingViewWidget symbol={cryptoDetails.symbol} type="crypto" height={400} />
                  <h5 className="mt-4 text-prime" style={{fontWeight:'900'}}>About {cryptoDetails.name}</h5>
                  <p className="mb-0" style={{fontSize:'14px'}}>{cryptoInfo.description}</p>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
    </div>
  )
}

export default Marketdetails